import React from "react";
import RegistarKontrola from "../../components/admin/registarKontrola";

function RegistarKontrolaPage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <RegistarKontrola />
    </div>
  );
}

export default RegistarKontrolaPage;
